import { useEffect } from "react";
import isFunction from "lodash/isFunction";
import { useLayoutContext } from "@/react/components/SettingsApp/Layout/LayoutContext";

interface SetLayoutConfigProps {
  disableRightSidebar: boolean;
  disableSidebar?: boolean;
  renderLeftSidebar?: () => React.ReactNode;
}

export const SetLayoutConfig = (props: SetLayoutConfigProps) => {
  const { mergeConfig } = useLayoutContext();

  useEffect(() => {
    if (isFunction(mergeConfig)) {
      mergeConfig(props);
    }
    // This hook needs to only run once. If we add deps to the hook then it goes into infinite update issue.
    // pass key to SetLayoutConfig if updating props.
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Intentionally empty deps as per comment above
  }, []);

  return null;
};
